import axios from 'axios';

const resolveBaseUrl = () => {
  const runtimeBaseUrl =
    typeof window !== 'undefined'
      ? window.__LABS_CONFIG__?.apiBaseUrl?.trim()
      : undefined;

  if (runtimeBaseUrl && runtimeBaseUrl !== '__LABS_API_BASE_URL__') {
    return runtimeBaseUrl;
  }

  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;

    if (host === 'localhost') {
      return 'https://localhost:44301';
    }

    if (host === 'labs-test.fastbar.tech') {
      return 'https://api-test.getfastbar.com';
    }

    if (host === 'labs.getfastbar.com') {
      return 'https://api.getfastbar.com';
    }
  }

  return '/api';
};

const api = axios.create({
  baseURL: resolveBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;